<template>
  <div class="accessNeededContainer bold">
    Une validation est nécessaire par l'association pour avoir accès à la partie réservée.<br>
    Veuillez prendre contact avec nous.
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  components: {
  },
  methods: {
  }
};
</script>

<style>
  .accessNeededContainer {
    text-align: center;
  }
</style>